import { render, staticRenderFns } from "./CreateDashboardLink.vue?vue&type=template&id=67241f1e&scoped=true"
import script from "./CreateDashboardLink.vue?vue&type=script&lang=js"
export * from "./CreateDashboardLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67241f1e",
  null
  
)

export default component.exports